<div class="d-flex w-100" [style.opacity]="disabled() ? 0.5 : 1">
    <telxl-avatar
        [presence]="item().presence?.class"
        [variant]="source()"
        [name]="item().name"
    />
    <div class="user d-flex justify-content-around flex-column pe-2">
        <div class="font-sm weight-medium truncate">
            {{ item().name }}
        </div>
        @if (view() !== 'none') {
            <div class="font-xs truncate">
                @if (view() === 'contact') {
                    @for (contact of contact(); track contact) {
                        <span class="me-1">
                            {{ contact }}
                        </span>
                    }
                    @if (contact().length === 0) {
                        <span class="me-1">No contact details</span>
                    }
                } @else if (view() === 'presence') {
                    <span class="me-1">
                        {{ status() }}
                    </span>
                }
            </div>
        }
    </div>
    @if (displayMediaIcons().length === 0) {
        <div class="button d-flex align-items-center">
            <ng-container customButtonTemplate()>
                <ng-container
                    *ngTemplateOutlet="
                        customButtonTemplate() ?? null;
                        context: { select: select.bind(this) }
                    "
                ></ng-container>
            </ng-container>
        </div>
    } @else {
        <div class="d-flex align-items-center">
            @for (icon of filteredMediaIcons(); track icon) {
                <div>
                    <i
                        [ngClass]="[iconClass(icon), !$first ? 'ms-3' : '']"
                        (click)="action(icon)"
                        (keyup)="action(icon)"
                        tabindex="0"
                    ></i>
                </div>
            }
        </div>
    }
</div>
